/* Don't Repeat Yourself */
document.addEventListener('DOMContentLoaded', function() {
	ps_infocard_modal();
	ps_handleVimeoAutoplay();
	ps_initVimeoPlayerControl();
	ps_initVideoSwitch();
	ps_initCloseButton();
	ps_initMobileCloseButton();
	ps_initSlider();
    updateVimeoVideo();
    window.addEventListener('resize', updateVimeoVideo);
});

function ps_infocard_modal(){
        // Handle .ps-trigger click
        const psTriggers = document.querySelectorAll('.ps-trigger');
		if (psTriggers.length === 0) {
			return; // Exit the function if no element are found
		}
        psTriggers.forEach(function(trigger) {
            trigger.addEventListener('click', function(e) {
                    const modal = trigger.closest('.hero-area-banner-wrap-v1')?.querySelector('.ps-cp-hero-modal');
                    if (modal) {
                        modal.classList.toggle('ps-show');
                    } 
                e.preventDefault();
            });
        });

        // Handle .ps-close click
        const psCloses = document.querySelectorAll('.ps-close');
		if (psCloses.length === 0) {
			return; // Exit the function if no element are found
		}
        psCloses.forEach(function(close) {
            close.addEventListener('click', function(e) {
                    const modal = close.closest('.hero-area-banner-wrap-v1')?.querySelector('.ps-cp-hero-modal');
                    if (modal) {
                        modal.classList.toggle('ps-show');
                    }
                e.preventDefault();
            });
        });

        // Handle .mobile-ps-close click
        const mobilePsCloses = document.querySelectorAll('.mobile-ps-close');
		if (mobilePsCloses.length === 0) {
			return; // Exit the function if no element are found
		}
        mobilePsCloses.forEach(function(close) {
            close.addEventListener('click', function(e) {
                    const modal = close.closest('.hero-area-banner-wrap-v1')?.querySelector('.ps-cp-hero-modal');
                    if (modal) {
                        modal.classList.toggle('ps-show');
                    }
                e.preventDefault();
            });
        });
}  


 function ps_handleVimeoAutoplay() {

	// Find the iframe within this container using the 'ps_herovideo_cls' class
	var iframes = document.querySelectorAll('.ps_herovideo_cls');
	if (iframes.length === 0) {
        return; // Exit the function if no element are found
    }
	// Loop through each iframe
	for (var i = 0; i < iframes.length; i++) {
		// Check if the iframe is a Vimeo video with autoplay enabled
		//console.log("Checking conditions",iframes[i].src.includes("vimeo.com"), iframes[i].src.includes("autoplay=1"));
		if (iframes[i].src.includes("vimeo.com") && iframes[i].src.includes("autoplay=1")) {
			// Create a new Vimeo player instance for the iframe
			setTimeout(() => {
				var player = new Vimeo.Player(iframes[i]);
				//console.log("Playing now", player)
			// Play the video
			player.play().catch(function(error) {
				console.error('Error playing video:', error);
			});
			}, 100);
			

			// Exit the loop after handling the first matching iframe
			break;
		}
	}
}


function ps_initVimeoPlayerControl() {
    // Check if there are any .ps-play-pause elements on the page
    const buttons = document.querySelectorAll('.ps-play-pause');
    
    if (buttons.length === 0) {
        return; // Exit the function if no element are found
    }

    // Loop through all .ps-play-pause buttons and add event listeners
    buttons.forEach(function(button) {
        button.addEventListener('click', function(e) {
            // Find the nearest parent container with the 'hero-area-banner-wrap-v1' class
            var container = this.closest('.hero-area-banner-wrap-v1');
            
            // Find the iframe within this container using the 'ps_herovideo_cls' class
            var iframe = container.querySelector('.ps_herovideo_cls');
            
            if (iframe) {
                // Initialize the Vimeo player
                var player = new Vimeo.Player(iframe);

                // Check if the video is paused
                player.getPaused().then(function(paused) {
                    if (paused) {
                        button.textContent = "Pause";
                        button.classList.remove('ps-play-pause-2');
                        player.play();
                    } else {
                        button.textContent = "Play";
                        button.classList.add('ps-play-pause-2');
                        player.pause();
                    }
                });
            }

            // Prevent default action (e.g., follow a link)
            e.preventDefault();
        });
    });
}


function ps_initVideoSwitch() {
    // Select all elements with the class '.ps-trigger'
	const psvTrigger = document.querySelectorAll('.ps-trigger');
    
    if (psvTrigger.length === 0) {
        return; // Exit the function if no element are found
    }
    psvTrigger.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
            // Find the nearest parent container with the 'hero-area-banner-wrap-v1' class
            var container = this.closest('.hero-area-banner-wrap-v1');
            
            // Check screen width
            let width = window.innerWidth; // Use window.innerWidth instead of screen.width for better control

            if (width > 960) {
                // For screens wider than 960px, use .ps_herovideo_cls and .ps_herovideo_popup_cls
                var video1 = container.querySelector('.ps_herovideo_cls');
                var video2 = container.querySelector('.ps_herovideo_popup_cls');

                if (video1 && video2) {
                    var player1 = new Vimeo.Player(video1);
                    var player2 = new Vimeo.Player(video2);

                    player1.pause();
                    player2.play();
                    // console.log('even', width);
                }
            } else {
                // For screens narrower than or equal to 960px, use .ps_herovideo_cls and .ps_mobile_herovideo_popup_cls
                var video1 = container.querySelector('.ps_herovideo_cls');
                var video3 = container.querySelector('.ps_mobile_herovideo_popup_cls');

                if (video1 && video3) {
                    var player1 = new Vimeo.Player(video1);
                    var player3 = new Vimeo.Player(video3);

                    player1.pause();
                    player3.play();
                    // console.log('odd', width);
                }
            }
        });
    });
}


function ps_initCloseButton() {
// Check if there are any .ps-close elements on the page
const closeButtons = document.querySelectorAll('.ps-close');
    
if (closeButtons.length === 0) {
	// console.log('No .ps-close elements found.');
	return; // Exit if no .ps-close elements exist
}

// If .ps-close elements exist, add event listeners to them
closeButtons.forEach(function(closeButton) {
	closeButton.addEventListener('click', function() {
		// Find the nearest parent container with the 'hero-area-banner-wrap-v1' class
		var container = this.closest('.hero-area-banner-wrap-v1');
		
		// Find the video elements inside this container with the classes '.ps_herovideo_cls' and '.ps_herovideo_popup_cls'
		var video1 = container.querySelector('.ps_herovideo_cls');
		var video2 = container.querySelector('.ps_herovideo_popup_cls');

		// Check if both videos exist in the container
		if (video1 && video2) {
			// Initialize Vimeo players for each video
			var player1 = new Vimeo.Player(video1);
			var player2 = new Vimeo.Player(video2);

			// Play the first video and pause the second
			player1.play();
			player2.pause();
		}
	});
});
}



function ps_initMobileCloseButton() {
    // Select all elements with the class '.mobile-ps-close'
    const closeButtons = document.querySelectorAll('.mobile-ps-close');
    
    // Check if .mobile-ps-close elements exist
    if (closeButtons.length === 0) {
        // console.log('No .mobile-ps-close elements found.');
        return; // Exit if no .mobile-ps-close elements exist
    }

    // Loop through each .mobile-ps-close button and add a click event listener
    closeButtons.forEach(function(closeButton) {
        closeButton.addEventListener('click', function() {
            // Find the nearest parent container with the '.hero-area-banner-wrap-v1' class
            var container = this.closest('.hero-area-banner-wrap-v1');
            
            // Find the video elements inside this container with the appropriate classes
            var video1 = container.querySelector('.ps_herovideo_cls');
            var video2 = container.querySelector('.ps_herovideo_popup_cls');
            var video3 = container.querySelector('.ps_mobile_herovideo_popup_cls');

            // Check if all three videos exist in the container
            if (video1 && video2 && video3) {
                // Initialize Vimeo players for each video
                var player1 = new Vimeo.Player(video1);
                var player2 = new Vimeo.Player(video2);
                var player3 = new Vimeo.Player(video3);

                // Play the first video and pause the second and third videos
                player1.play();
                player2.pause();
                player3.pause();
            }
        });
    });
}



function ps_initSlider() {
    // Get all sliders inside '.hero-area-banner-wrap'
    var sliders = document.querySelectorAll('.hero-area-banner-wrap .slides');

    // Check if sliders exist
    if (sliders.length === 0) {
        return; // Exit the function if no sliders exist
    }

    // Loop through each slider and add the necessary event listeners
    sliders.forEach(function(slider) {
        var isDown = false;
        var startX;
        var scrollLeft;

        // Make each li focusable and add ARIA label
        var items = slider.querySelectorAll('li');
        items.forEach(function(item, index) {
            item.setAttribute('tabindex', '0');
            item.setAttribute('aria-label', 'Slide ' + (index + 1));
        });

        // Mouse events for dragging
        slider.addEventListener('mousedown', function(e) {
            isDown = true;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener('mouseleave', function() {
            isDown = false;
            slider.classList.remove('active');
        });

        slider.addEventListener('mouseup', function() {
            isDown = false;
            slider.classList.remove('active');
        });

        slider.addEventListener('mousemove', function(e) {
            if (!isDown) return;
            e.preventDefault();
            var x = e.pageX - slider.offsetLeft;
            var walk = (x - startX) * 3; //scroll-fast
            slider.scrollLeft = scrollLeft - walk;
        });

        // Touch events for dragging
        slider.addEventListener('touchstart', function(e) {
            isDown = true;
            slider.classList.add('active');
            startX = e.touches[0].pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        }, false);

        slider.addEventListener('touchend', function() {
            isDown = false;
            slider.classList.remove('active');
        }, false);

        slider.addEventListener('touchmove', function(e) {
            if (!isDown) return;
            e.preventDefault();
            var x = e.touches[0].pageX - slider.offsetLeft;
            var walk = (x - startX);
            slider.scrollLeft = scrollLeft - walk;
        }, false);
    });
}

  // Function to update the iframe based on the screen width
  function updateVimeoVideo() {
    const iframe = document.getElementById('intro_video');
    if(iframe){
    const isMobile = window.innerWidth <= 960;
    
    // Get the URLs from hidden input fields
    const desktopUrl = document.getElementById('ps-vimeo-desktop-url').value;
    const mobileUrl = document.getElementById('ps-vimeo-mobile-url').value;

    // Set the iframe src to the appropriate URL based on screen size
    iframe.src = isMobile ? mobileUrl : desktopUrl;
    }
  }